import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-black border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_sepa-merchants-demo/artifacts/p11t5rmo_F7FB5692-8EC3-47F3-9917-09F08B4B4E2E%202.PNG" 
                alt="CentrixPay Logo"
                className="w-22 h-18 object-contain"
                style={{ width: '88px', height: '72px' }}
              />
              <span className="text-xl font-bold text-white font-display">CentrixPay</span>
            </Link>
            <p className="text-zinc-400 text-sm leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="flex gap-3 mt-6">
              <div className="px-3 py-1.5 bg-white/5 border border-white/10 rounded-md">
                <span className="text-xs text-zinc-400 font-mono">PSD2</span>
              </div>
              <div className="px-3 py-1.5 bg-white/5 border border-white/10 rounded-md">
                <span className="text-xs text-zinc-400 font-mono">GDPR</span>
              </div>
              <div className="px-3 py-1.5 bg-white/5 border border-white/10 rounded-md">
                <span className="text-xs text-zinc-400 font-mono">PCI DSS</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.services')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-zinc-400 hover:text-emerald-400 text-sm transition-colors">
                  Card Processing
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-zinc-400 hover:text-emerald-400 text-sm transition-colors">
                  SEPA Payments
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-zinc-400 hover:text-emerald-400 text-sm transition-colors">
                  Multi-Currency
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-zinc-400 hover:text-emerald-400 text-sm transition-colors">
                  POS Terminals
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.company')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-zinc-400 hover:text-emerald-400 text-sm transition-colors">
                  {t('footer.about')}
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-zinc-400 hover:text-emerald-400 text-sm transition-colors">
                  {t('footer.careers')}
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-zinc-400 hover:text-emerald-400 text-sm transition-colors">
                  {t('footer.blog')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-zinc-400 hover:text-emerald-400 text-sm transition-colors">
                  {t('footer.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.legal')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-zinc-400 hover:text-emerald-400 text-sm transition-colors">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-zinc-400 hover:text-emerald-400 text-sm transition-colors">
                  {t('footer.terms')}
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-zinc-400 hover:text-emerald-400 text-sm transition-colors">
                  {t('footer.cookies')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 text-sm">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-6">
            <span className="text-zinc-500 text-xs">SEPA • EUR • CZK • PLN</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
